export default {
  home: '/home',
  scan: '/escanear',
  more: {
    root: '/mais',
    charging_history: 'mais/historico-de-carregamento',
    terms: 'mais/termos-de-uso',
    help: 'mais/suporte',
  },
  chargings: {
    root: '/carregamentos',
    charging_detail: 'carregamentos/detalhe',

  },
  payment_methods: '/metodos-de-pagamento',
  credit_cards: '/cartoes-de-credito',
  add_card: '/novo-cartão',
  gas_station: '/local',
  login: '/entrar',
  register: '/cadastro',
  not_logged: '/deslogado',
} as const


